<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="facilityForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="facility" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    import facilityTypeEnum from '../enums/facilityType'

    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                facility: () => import('../editViews/Facility'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Name', value: 'name' },
                    { text: 'Facility Type', value: 'facilityTypes', formatEnum: facilityTypeEnum },
                    { text: 'Address', value: 'addressId', table: 'addresses', form: () => import('../forms/AddressForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    addresses: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "addressId", direction: "ascending" },
                ],
                itemsField: 'facilities',
                editPageName: 'facility',
                apiMethod: 'Facilities',
                claimName: 'Facilities',
                formTitle: 'Facility',
                excelTitle: 'Facilities',
                hasEditPage: true,
            }
        },
    };
</script>
